import { useCallback, useEffect, useState } from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CreateIcon from '@mui/icons-material/Create';
import { useStyles } from '../announcement.style';
import { GetAnnouncements, DeleteAnnouncement } from "../../../DAL/Announcements/announcements";
import { enqueueSnackbar } from "notistack";

export const useAnnouncement = () => {
  const classes = useStyles();
  const [AnnouncementData, setAnnouncementData] = useState([]);
  const [AnnouncementCount, setAnnouncementCount] = useState(0);
  const [singleAnnouncement, setsingleAnnouncement] = useState('');
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState('');
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false)
  
  const tableCells = [
    { id: 'title', title: 'Title', width: '12%', maxWidth: 140 },
    { id: 'description', title: 'Description', width: '14%', maxWidth: 160 },
    { id: 'isExternal', title: 'Internal', width: '6%', maxWidth: 70 },
    { id: 'bookId', title: 'Book', width: '10%', maxWidth: 110 },
    { id: 'chapterId', title: 'Chapter', width: '10%', maxWidth: 110 },
    { id: 'pageNo', title: 'Page', width: '5%', maxWidth: 55 },
    { id: 'link', title: 'Link', width: '10%', maxWidth: 120 },
    { id: 'scheduledAt', title: 'Scheduled', width: '10%', maxWidth: 115 },
    { id: 'url', title: 'Image', width: '7%', maxWidth: 70 },
    { id: 'actions', title: 'Actions', width: '8%', maxWidth: 80 },
  ];
  const actionsIcons = [
    { icon: <DeleteOutlineOutlinedIcon className={classes.iconStyle} />, action: "delete" },
    { icon: <CreateIcon className={classes.iconStyle} />, action: "edit" },
  ];

  useEffect(() => {
    getAnnouncementsData(page, limit);
  }, [page, limit]);

  const getAnnouncementsData = useCallback(async(page, limit) => {
    setIsLoading(true)
    let data = {
      page: Math.max(page + 1, 1),
      limit: limit,
    }
    const response = await GetAnnouncements(data);
        if (response.statusCode == 200) {
          setIsLoading(false);
          setAnnouncementData(response?.data?.rows);
          setAnnouncementCount(response?.data?.count);
    
        } else {
          setIsLoading(false);
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleDelete = useCallback(async(id) => {
    const response = await DeleteAnnouncement(id); 
        if (response.statusCode == 200) {
          getAnnouncementsData(page, limit)
        } else {
          if (typeof response.message == "string") {
            enqueueSnackbar(response.message, { variant: "error" });
          } else {
            enqueueSnackbar("Invalid credentials", { variant: "error" });
          }
        }
  }, []);

  const handleAdd = useCallback(() => {
    setAction('add');
    setOpen(true);
  }, []);

  const handleActionClick = useCallback((index, row) => {
    setsingleAnnouncement(row);
    if (index === 0) {
      setAction('delete');
      handleDelete(row.id);
    }
    if (index === 1) {
      setAction('update');
      setOpen(true);
    }
  }, []);

  const handleChangePage = useCallback((isTrue, newPage) => {
    if (isTrue) {
      setPage(newPage - 1);
    } else {
      setPage(newPage);
    }
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const calculatePagesCount = (pageSize, totalCount) => {
    return totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
  };

  const handleGetAnnouncementData = useCallback(value => {
    getAnnouncementsData(page, limit)
  }, []);

  return {
    AnnouncementData,
    AnnouncementCount,
    singleAnnouncement,
    open,
    action,
    tableCells,
    actionsIcons,
    page,
    limit,
    isLoading,
    setOpen,
    handleGetAnnouncementData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
  };
};
